import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ExternalLink } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import * as mockFr from '../../data/mock';
import * as mockAr from '../../data/mock-ar';

const Footer = () => {
  const { language } = useLanguage();
  const data = language === 'ar' ? mockAr : mockFr;
  const { companyInfo, navigationLinks, ui } = data;

  return (
    <footer className="bg-[#141615] border-t border-white/10">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <img
              src={companyInfo.logo}
              alt="PREBATI"
              className="h-14 w-auto mb-6"
            />
            <p className="text-white/60 body-medium mb-4 max-w-md">
              {ui?.firstFactory || 'Première usine mauritanienne de planchers en béton précontraint'}
            </p>
            <p className="text-white/50 body-small mb-6">
              {ui?.underLicense || 'Sous licence OTEP France'}
            </p>
            <div className="flex flex-col gap-3">
              <a
                href={`tel:${companyInfo.phone}`}
                className="flex items-center gap-3 text-white/70 hover:text-white transition-colors"
              >
                <Phone className="w-5 h-5 text-[#c4291c]" />
                <span>{companyInfo.phone}</span>
              </a>
              <a
                href={`mailto:${companyInfo.email}`}
                className="flex items-center gap-3 text-white/70 hover:text-white transition-colors"
              >
                <Mail className="w-5 h-5 text-[#c4291c]" />
                <span>{companyInfo.email}</span>
              </a>
              <div className="flex items-center gap-3 text-white/70">
                <MapPin className="w-5 h-5 text-[#c4291c]" />
                <span>{companyInfo.location}</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6">{ui?.navigation || 'Navigation'}</h4>
            <nav className="flex flex-col gap-3">
              {navigationLinks.slice(0, 4).map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-white/60 hover:text-white transition-colors body-small"
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* More Links */}
          <div>
            <h4 className="text-white font-semibold mb-6">{ui?.resources || 'Ressources'}</h4>
            <nav className="flex flex-col gap-3">
              {navigationLinks.slice(4).map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-white/60 hover:text-white transition-colors body-small"
                >
                  {link.name}
                </Link>
              ))}
              <a
                href="https://wa.me/22243111616?text="
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#c4291c] hover:text-[#a82318] transition-colors body-small font-medium"
              >
                {ui?.requestQuote || 'Demander un devis'}
              </a>
            </nav>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/40 text-sm">
              © {new Date().getFullYear()} PREBATI. {ui?.allRightsReserved || 'Tous droits réservés.'}
            </p>
            <a
              href={`https://${companyInfo.website}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-white/40 hover:text-white/60 text-sm transition-colors"
            >
              <span>{companyInfo.website}</span>
              <ExternalLink className="w-3 h-3" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
